import { DnaIcon } from 'morpheus-ui';
import { Fragment, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useNavigate } from 'react-router-dom';
import getSubjectByFilter from '../../../../core/commom/getSubjectByFilter';
import ContentLoading from '../../../../core/components/atoms/ContentLoading';
import InnerHTMLContainer from '../../../../core/components/molecules/InnerHTMLContainer';
import { Typography } from '../../../../core/components/molecules/Typography';
import ContentCard from '../../../../core/components/organism/ContentCard';
import NewPrintComponent from '../../../../core/components/organism/PrintComponent/newPrintComponent';
import { usePrintComponentStore } from '../../../../core/components/organism/PrintComponent/store/usePrintComponentStore';
import { useExercisePageStore } from '../../stores/exercisePageStore';
import ExercisePaper from '../../../../core/components/templates/PrintPaper/exercises';
import { Colors } from '../../../../core/models/disciplines';
import { getDisciplineIcon } from '../../../../core/utils/new_discipline';
import { IResponseFavorite } from '../../hooks/useContentFavorite';
import { useNewExerciseHook } from '../../hooks/useNewExercise';
import { useDisciplinesAuxStore } from '../../stores/auxStore';
import { useExerciseStore } from '../../stores/exercisesStore';
import { useNewSubjectStore } from '../../stores/newSubjectStore';
import { getModuleDescription, getModuleLabel } from '../../utils/contentHelper';
import CardLoader from '../cardLoading';
import DisciplinesEmptyState from '../EmptyState';
import SectionHeader from '../sectionHeader';
import FilterModal from './components/filterModal';

interface IExerciseList {
  module: string;
  discipline: Colors;
  url: string;
}

export default function ExerciseList({ module, discipline, url }: IExerciseList) {
  const navigate = useNavigate();

  const { mutate, isPending } = useNewExerciseHook();
  const { selectedSubjects } = useNewSubjectStore();
  const { exercises, totalExercises, setExercises } = useExerciseStore();
  const { setHasApiCall } = usePrintComponentStore();
  const { openModal, setOpenModal } = useDisciplinesAuxStore()

  const [page, setPage] = useState<number>(1);

  useEffect(() => {
    if(module) {
      mutate({ module, operation: 'initial', page: 1 });
    }
  }, [selectedSubjects]);

  useEffect(() => {
    if (totalExercises && exercises.length < totalExercises && page > 1) {
      mutate({ module, operation: 'pagination', page });
    }
  }, [page]);

  useEffect(() => {
    if (typeof window?.MathJax !== 'undefined') {
      window.MathJax.typesetPromise();
    }
  });

  const callbackFav = (data: IResponseFavorite) => {
    if (!data.ok) return;

    const isNowFavorite = !!data.insert;

    const updated = exercises.map((ex) =>
      ex.id === data.targetId ? { ...ex, favorite: isNowFavorite } : ex
    );

    setExercises(updated);
    useExercisePageStore.getState().setExercises(updated);
  }


  if (isPending && page === 1) {
    return (
      <Fragment>
        {Array.from({ length: 10 }, (_, index) => (
          <CardLoader key={index} />
        ))}
      </Fragment>
    );
  }

  return (
    <div className='flex flex-col gap-lg'>
      <NewPrintComponent 
        type='exercise'
        isOpen={openModal === 'exercise-print'}
        onClose={() => {
          setHasApiCall(false);
          setOpenModal(undefined);
        }}
        title={getModuleLabel(module || '')}
        subtitle={getModuleDescription(module || '')}
      >
        <ExercisePaper 
          cols="split" 
          size="default" 
          color={(discipline as Colors) ?? 'anatomia-superior'}
          iconType='svg'
          icon={getDisciplineIcon(discipline || "") || DnaIcon}
          title={module ?? ""}
          module={discipline ?? ""}
        /> 
      </NewPrintComponent>
      <FilterModal
        isOpen={openModal === 'exercise-filter'}
        onClose={() => setOpenModal(undefined)}
        onSubmit={() => { 
          setPage(1);
          mutate({ module, operation:'filter', page: 1 });
        }}
        subtitle={getModuleLabel(module || '')}
      />
      {!exercises || exercises.length === 0 ? <DisciplinesEmptyState /> : (
        <Fragment>
          <SectionHeader hasTitle={false}>
            <div className='flex h-fit w-full flex-row items-center gap-lg xs:justify-between md:justify-end'>
              <Typography size='small'>
                {totalExercises || 0}{' '}
                {!exercises || !totalExercises || totalExercises <= 1
                  ? 'exercício'
                  : 'exercícios'}
              </Typography>
            </div>
          </SectionHeader>
          <InfiniteScroll
            dataLength={exercises.length}
            next={() => setPage(page + 1)}
            hasMore={totalExercises ? exercises.length < totalExercises : false}
            loader={<ContentLoading type='list' />}
            className='flex flex-col gap-lg bg-color-transparent'
            style={{ overflow: 'visible' }}
          >
            {exercises &&
              exercises.map((it, i) => (
                <ContentCard
                  color={discipline}
                  key={i}
                  content='Exercício'
                  favorite={it.favorite}
                  icon='edit'
                  action={() => navigate(url + `/assunto/${it.subjects[0].slug}/exercicio/${it.slug}`)}
                  // subject={it.subjects[0].title}
                  subject={getSubjectByFilter(it.subjects, selectedSubjects)}
                  id={it.id}
                  done={it.done}
                  hasCallback
                  callback={(data) => callbackFav(data)}
                >
                  <InnerHTMLContainer
                    data={it.statement}
                    type='contentCard'
                    align='left'
                    font='noto'
                    className='text-sm text-mono-color-darkest transition delay-100 ease-in-out group-hover:text-card-color-default'
                  />
                </ContentCard>
              ))}
          </InfiniteScroll>
        </Fragment>
      )}
    </div>
  );
}
